module.exports = [{
      plugin: require('/opt/build/repo/node_modules/gatsby-source-prismic-graphql/gatsby-browser.js'),
      options: {"plugins":[],"repositoryName":"mad-example","path":"/preview","previews":true,"pages":[{"type":"Product","match":"/products/:uid","path":"/product","component":"/opt/build/repo/src/templates/product.js"},{"type":"Blog_post","match":"/blog/:uid","path":"/blogpost","component":"/opt/build/repo/src/templates/blogPost.js"},{"type":"Landingpage","match":"/landingpage/:uid","path":"/landingpage","component":"/opt/build/repo/src/templates/landingpage.js"}]},
    },{
      plugin: require('/opt/build/repo/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
